import React from 'react';
import { Link } from 'react-router-dom';
import PageContainer from '../components/common/PageContainer';
import { imagePath } from '../utils/imagePath';

/**
 * NotFoundPage - 404 error page
 * Follows React Rules: Pure component
 */
const NotFoundPage = () => {
  return (
    <PageContainer>
      <div className="error-404-area pt-60 pb-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="error-404-content text-center">
                <h1>404</h1>
                <h2>Oops! Page Not Found</h2>
                <p>Sorry, the page you are looking for does not exist or has been moved.</p>
                <div className="error-404-button">
                  <Link to="/store" className="btn">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default NotFoundPage;
